import React from "react"

const arr = [
    {
        id: 0,
        value: "Mar"
    },
    {
        id: 1,
        value: "Apr"
    },
    {
        id: 2,
        value: "May"
    },
    {
        id: 3,
        value: "Jun"
    },
    {
        id: 4,
        value: "Jul"
    },
    {
        id: 5,
        value: "Aug"
    },
    {
        id: 6,
        value: "Sep"
    },
    {
        id: 7,
        value: "Oct"
    },
    {
        id: 8,
        value: "Nov"
    },    {
        id: 9,
        value: "Dec"
    },    {
        id: 10,
        value: "Jan"
    },
]

export default arr;
